import { UserVuetifyPreset } from 'vuetify';

const config: Partial<UserVuetifyPreset> = {
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#fbd929',
        secondary: '#6c757d',
        accent: '#82B1FF',
        error: '#fc6129',
        info: '#17a2b8',
        success: '#54cf4b',
        warning: '#ffc107',
        icon: '#adb371',
        'primary-light-4': '#f3e9d2',
        'primary-light-3': '#e9e9e9',
        'primary-light-2': '#fdefa7',
        'primary-light-1': '#fef6cd',
        'primary-light': '#fffce7',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
};

export default config;
